import { TABLE_PREFERENCES_URL } from "../../context/paths";

const headers = (token) => ({ "Content-Type": "application/json", authorization: `Bearer ${token}` });

export const fetchTablePreferences = async (token) => {
    const response = await fetch(TABLE_PREFERENCES_URL, { method: "GET", headers: headers(token) });
    const body = await response.json();
    if (!response.ok || body?.type !== "success") {
        throw new Error(body?.message || "Falha ao carregar preferências de tabela");
    }
    return body.data ?? {};
};

export const saveTablePreference = async (token, tableKey, layout) => {
    const response = await fetch(`${TABLE_PREFERENCES_URL}/${tableKey}`, {
        method: "PUT",
        headers: headers(token),
        body: JSON.stringify(layout),
    });
    if (!response.ok) throw new Error("Falha ao salvar preferências de tabela");
};

export const deleteTablePreference = async (token, tableKey) => {
    const response = await fetch(`${TABLE_PREFERENCES_URL}/${tableKey}`, { method: "DELETE", headers: headers(token) });
    if (!response.ok) throw new Error("Falha ao restaurar preferências de tabela");
};
